import { render, staticRenderFns } from "./FloorList.vue?vue&type=template&id=35d1cb88&scoped=true&"
import script from "./FloorList.vue?vue&type=script&lang=js&"
export * from "./FloorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1cb88",
  null
  
)

export default component.exports